import Box, { BoxProps } from '@material-ui/core/Box'
import Hidden, { HiddenProps } from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import React, { memo } from 'react'
import useStyles from './Logo.style'

export interface LogoViewProps {
  /**
   * Color to use
   */
  color?: string
  /**
   * How large should the button be?
   */
  logoSize?: number
  /**
   * Show name
   */
  showName?: boolean
  /**
   * Show name hidden props
   */
  showNameHiddenProps?: HiddenProps
  /**
   * Flex alignment for the name
   */
  nameAlignment?: string
  /**
   * Optional click handler
   */
  clickHandler?: () => void
}

const LogoView: React.FC<LogoViewProps & BoxProps> = ({
  clickHandler,
  showName,
  showNameHiddenProps,
  color = '#000000',
  logoSize = 24,
  nameAlignment = 'flex-start',
  ...props
}) => {
  const classes = useStyles()
  return (
    <Box display='flex' flexDirection='column' alignItems={nameAlignment} justifyContent='center' onClick={clickHandler} {...props}>
      <svg preserveAspectRatio='xMidYMid meet' viewBox='0 0 197 38' height={logoSize} xmlns='http://www.w3.org/2000/svg' version='1.0'>
        <path
          d='M0.203125 0.367188H18.8359C21.6484 0.367188 24.0859 0.664063 26.1484 1.25781C28.2109 1.83594 29.9219 2.67969 31.2812 3.78906C32.6406 4.89844 33.6484 6.25 34.3047 7.84375C34.9766 9.4375 35.3125 11.2422 35.3125 13.2578C35.3125 14.6172 35.1484 15.9141 34.8203 17.1484C34.4922 18.3672 33.9844 19.4922 33.2969 20.5234C32.625 21.5547 31.7734 22.4766 30.7422 23.2891C29.7109 24.0859 28.5 24.75 27.1094 25.2812L35.0781 37H25.9844L19.0938 26.5938H18.8828L7.63281 26.5703V37H0.203125V0.367188ZM19.0234 20.1484C20.4297 20.1484 21.6562 19.9844 22.7031 19.6562C23.7656 19.3281 24.6484 18.8672 25.3516 18.2734C26.0703 17.6797 26.6016 16.9609 26.9453 16.1172C27.3047 15.2578 27.4844 14.3047 27.4844 13.2578C27.4844 11.2109 26.7812 9.63281 25.375 8.52344C23.9688 7.39844 21.8516 6.83594 19.0234 6.83594H7.63281V20.1484H19.0234ZM51.3372 0.367188H59.2122L76.9309 37H69.1263L66.1966 30.8359H44.7981L41.9622 37H34.1341L51.3372 0.367188ZM63.2669 24.7188L55.345 8.07812L47.6341 24.7188H63.2669ZM77.3463 0.367188H95.9791C98.7916 0.367188 101.229 0.664063 103.292 1.25781C105.354 1.83594 107.065 2.67969 108.424 3.78906C109.784 4.89844 110.792 6.25 111.448 7.84375C112.12 9.4375 112.456 11.2422 112.456 13.2578C112.456 14.6172 112.292 15.9141 111.963 17.1484C111.635 18.3672 111.128 19.4922 110.44 20.5234C109.768 21.5547 108.917 22.4766 107.885 23.2891C106.854 24.0859 105.643 24.75 104.253 25.2812L112.221 37H103.128L96.2369 26.5938H96.0259L84.7759 26.5703V37H77.3463V0.367188ZM96.1666 20.1484C97.5728 20.1484 98.7994 19.9844 99.8463 19.6562C100.909 19.3281 101.792 18.8672 102.495 18.2734C103.213 17.6797 103.745 16.9609 104.088 16.1172C104.448 15.2578 104.628 14.3047 104.628 13.2578C104.628 11.2109 103.924 9.63281 102.518 8.52344C101.112 7.39844 98.9947 6.83594 96.1666 6.83594H84.7759V20.1484H96.1666ZM114.605 0.367188H122.035V20.5469C122.035 22.2031 122.262 23.6797 122.715 24.9766C123.168 26.2578 123.84 27.3438 124.73 28.2344C125.637 29.125 126.754 29.8047 128.082 30.2734C129.41 30.7266 130.957 30.9531 132.722 30.9531C134.472 30.9531 136.012 30.7266 137.34 30.2734C138.683 29.8047 139.801 29.125 140.691 28.2344C141.597 27.3438 142.277 26.2578 142.73 24.9766C143.183 23.6797 143.41 22.2031 143.41 20.5469V0.367188H150.84V21.4375C150.84 23.8438 150.433 26.0312 149.621 28C148.808 29.9688 147.629 31.6562 146.082 33.0625C144.535 34.4688 142.637 35.5547 140.387 36.3203C138.152 37.0859 135.597 37.4688 132.722 37.4688C129.847 37.4688 127.285 37.0859 125.035 36.3203C122.801 35.5547 120.91 34.4688 119.363 33.0625C117.816 31.6562 116.637 29.9688 115.824 28C115.012 26.0312 114.605 23.8438 114.605 21.4375V0.367188ZM154.653 0.367188H162.083L175.396 13.7266L188.708 0.367188H196.138V37H188.708V10.6562L175.396 23.4766L162.083 10.6562V37H154.653V0.367188Z'
          fill={color}
        />
      </svg>
      {showName && (
        <Hidden {...showNameHiddenProps}>
          <Box>
            <Typography variant='h4' className={classes.brandText} style={{ color, fontSize: `${logoSize / 37}rem` }}>
              Sustainable NFT Collectibles
            </Typography>
          </Box>
        </Hidden>
      )}
    </Box>
  )
}

export default memo(LogoView)
